import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCollapsed: false,
  mobileOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    toggleMobileSidebar: (state) => {
      state.mobileOpen = !state.mobileOpen;
    },
    setSidebarState: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setMobileSidebarState: (state, action) => {
      state.mobileOpen = action.payload;
    },
  },
});

export const { 
  toggleSidebar, 
  toggleMobileSidebar, 
  setSidebarState,
  setMobileSidebarState 
} = sidebarSlice.actions;

export default sidebarSlice.reducer; 